// Mini-courbe SVG (aucune dépendance) : une polyligne à l'échelle des
// valeurs, dernier point marqué. Sert aux lignes « par état » de la fiche et
// aux lignes de la vue Œil de Sauron. Rien n'est tracé sous 2 valeurs.
export const Sparkline = ({ values = [], width = 70, height = 22, color = "#f59e0b", className = "" }) => {
  const vals = values.filter(v => typeof v === "number" && !Number.isNaN(v));
  if (vals.length < 2) return <svg width={width} height={height} className={className} aria-hidden="true" />;
  const P = 2;
  let min = Math.min(...vals), max = Math.max(...vals);
  if (max === min) { max += 1; min -= 1; }
  const pts = vals.map((v, i) => [
    P + (i * (width - 2 * P)) / (vals.length - 1),
    P + (1 - (v - min) / (max - min)) * (height - 2 * P),
  ]);
  const d = pts.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(" ");
  const last = pts[pts.length - 1];
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className={className} aria-hidden="true">
      <path d={d} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
      <circle cx={last[0].toFixed(1)} cy={last[1].toFixed(1)} r="2" fill={color} />
    </svg>
  );
};
